import React from "react";
import styles from "./emptyWorkSpace/EmptyWorkSpace.module.scss";
import Button from "../../Componnets/Button/Button";
import ButtonWithIcon from "../../Componnets/ButtonWithIcon/ButtonWithIcon";

const EmptyWorkSpace = ({ handleShowCreateWorkspaceModal }) => {

    return (
        <div className={styles.EmptyWorkSpace + ' d-flex align-items-center pl-4'}>
            <div>
                <div className={styles.backgroundTop}>
                    <svg width="623" height="390" viewBox="0 0 623 390" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect opacity="0.6" x="14.1421" y="78.127" width="420" height="420" rx="73" transform="rotate(-45 14.1421 78.127)" stroke="#F0F2FF" stroke-width="20"/>
                    </svg>
                </div>
                <div className={styles.backgroundBottom}>
                    <svg width="482" height="369" viewBox="0 0 482 369" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect opacity="0.6" x="14.1421" y="311.127" width="420" height="420" rx="73" transform="rotate(-45 14.1421 311.127)" stroke="#F0F2FF" stroke-width="20"/>
                    </svg>
                </div>
                <div className={styles.logo}>
                    <svg width="148" height="120" viewBox="0 0 148 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g opacity="0.5">
                            <g opacity="0.5">
                                <g opacity="0.5">
                                    <g opacity="0.5">
                                        <path opacity="0.5" d="M147.042 98.7928H0V119.701H147.042V98.7928Z" fill="url(#paint0_radial)"/>
                                    </g>
                                </g>
                            </g>
                        </g>
                        <path d="M120.237 38.8502L112.677 31.2976L70.4161 73.5142H94.8244C95.4282 72.2474 96.4568 71.2317 97.7318 70.6434C99.0068 70.055 100.448 69.9311 101.805 70.2932C103.162 70.6553 104.349 71.4805 105.16 72.6256C105.972 73.7708 106.356 75.1636 106.247 76.5623C106.138 77.9611 105.543 79.2777 104.563 80.2835C103.584 81.2893 102.283 81.9209 100.887 82.0687C99.49 82.2166 98.0856 81.8713 96.9171 81.0928C95.7486 80.3144 94.8899 79.1518 94.4898 77.8069H64.0868C59.8315 77.8069 62.7361 75.1143 62.7361 75.1143L109.634 28.2587L86.6903 5.33241C83.2494 1.91696 78.5957 0 73.745 0C68.8943 0 64.2406 1.91696 60.7997 5.33241L27.2472 38.8502C23.8252 42.2859 21.9043 46.9354 21.9043 51.782C21.9043 56.6286 23.8252 61.2781 27.2472 64.7139L34.8075 72.2425L76.9724 30.1513H52.5759C51.9718 31.4176 50.943 32.4327 49.6681 33.0206C48.3931 33.6085 46.9524 33.732 45.5958 33.3698C44.2392 33.0075 43.0523 32.1824 42.241 31.0375C41.4297 29.8925 41.0452 28.5 41.154 27.1015C41.2629 25.703 41.8584 24.3866 42.8372 23.3808C43.8159 22.3749 45.1163 21.7431 46.5126 21.5947C47.909 21.4464 49.3132 21.791 50.4819 22.5687C51.6505 23.3464 52.5098 24.5082 52.9106 25.8526H83.3195C87.5689 25.8526 84.6642 28.5453 84.6642 28.5453L37.8436 75.3053L60.7997 98.2316C64.2406 101.647 68.8943 103.564 73.745 103.564C78.5957 103.564 83.2494 101.647 86.6903 98.2316L120.237 64.7139C123.659 61.2781 125.58 56.6286 125.58 51.782C125.58 46.9354 123.659 42.2859 120.237 38.8502Z" fill="#8A0FFF"/>
                        <defs>
                            <radialGradient id="paint0_radial" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(73.9781 108.333) scale(69.1269 8.71008)">
                                <stop stop-color="#231F20"/>
                                <stop offset="0.15" stop-color="#464344"/>
                                <stop offset="0.74" stop-color="#CAC9C9"/>
                                <stop offset="1" stop-color="white"/>
                            </radialGradient>
                        </defs>
                    </svg>
                </div>
                <div className={styles.title}>
                    Welcome to Rahkav!
                </div>
                {
                    localStorage.getItem("role") !== "viewer" &&
                      <>
                          <div className={styles.description}>
                              Creating a Workspace Is Where You Can Start
                              <p>To Start Your Flow in ProcessMining Let's Create a Workspace</p>
                          </div>
                          <div className={styles.newWorkSpace}>
                              <ButtonWithIcon onClick={handleShowCreateWorkspaceModal} hasShadow>
                                  <div>
                                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M12.0001 8.32733V15.6537" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                          <path d="M15.6666 11.9905H8.33325" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                          <path fill-rule="evenodd" clip-rule="evenodd" d="M16.6857 2H7.31429C4.04762 2 2 4.31208 2 7.58516V16.4148C2 19.6879 4.0381 22 7.31429 22H16.6857C19.9619 22 22 19.6879 22 16.4148V7.58516C22 4.31208 19.9619 2 16.6857 2Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                      </svg>
                                  </div>
                                  <div>New Workspace</div>
                              </ButtonWithIcon>
                          </div>
                      </>
                }
            </div>
        </div>
    )
};

export default EmptyWorkSpace;
